export const initialValues = {
  name: '',
  phoneNumber: '',
};

export const initialErrors = {
  name: '',
  phoneNumber: '',
};

export const validateForm = (values: Partial<typeof initialValues>): Partial<typeof initialErrors> => {
  const errors: Partial<typeof initialErrors> = {};
  const phoneRegExp = /^(\+88)?01[3-9]{1}[0-9]{8}$/;

  if (values && Object.keys(values).length > 0) {
    for (const key of Object.keys(values) as (keyof typeof initialValues)[]) {
      if (key in initialErrors) {
        switch (key) {
          case 'name':
            errors.name = !values.name ? 'Name is required' : '';
            break;
          case 'phoneNumber':
            if (!values.phoneNumber) {
              errors.phoneNumber = 'Phone number is required';
            } else if (!phoneRegExp.test(values.phoneNumber)) {
              errors.phoneNumber = 'Phone number is invalid';
            } else {
              errors.phoneNumber = '';
            }
            break;
          default:
            break;
        }
      }
    }
  }

  return errors;
};
